import { globalState } from "../../framework/globalState.ts";
import { updateCurrentUser } from "../../services/api.ts";

export default function ProfilePage() {
  const container = document.createElement("div");
  container.classList.add("parent-container");

  const user = globalState.user;

  container.innerHTML = `
    <div class="container-layout full-height">
      <div class="container-column" style="max-width:600px; margin:0 auto;">
        <div class="column-header">
          <div class="header-title has-icon">
            <span class="iconify" data-icon="mdi:account-circle-outline"></span>
            <h3>Profile</h3>
          </div>
        </div>
        <div class="container-body" style="padding:24px;">
          <div style="text-align:center; margin-bottom:24px;">
            <div style="width:80px;height:80px;border-radius:50%;background:#374151;display:inline-flex;align-items:center;justify-content:center;font-size:32px;color:#fff;">
              ${(user?.name || 'U').charAt(0).toUpperCase()}
            </div>
            <h2 style="margin-top:12px;">${user?.name || 'User'}</h2>
            <p style="opacity:0.6;">${user?.role || 'Operator'}</p>
          </div>

          <form id="profile-form" style="display:flex; flex-direction:column; gap:14px;">
            <label>
              <span style="font-size:13px; opacity:0.7;">Full Name</span>
              <input type="text" name="name" value="${user?.name || ''}" class="form-input" style="width:100%; padding:8px; border-radius:6px; border:1px solid #4b5563; background:#1f2937; color:#fff;" />
            </label>
            <label>
              <span style="font-size:13px; opacity:0.7;">Email</span>
              <input type="email" name="email" value="${user?.email || ''}" class="form-input" style="width:100%; padding:8px; border-radius:6px; border:1px solid #4b5563; background:#1f2937; color:#fff;" />
            </label>
            <label>
              <span style="font-size:13px; opacity:0.7;">Role</span>
              <input type="text" value="${user?.role || ''}" disabled style="width:100%; padding:8px; border-radius:6px; border:1px solid #374151; background:#111827; color:#9ca3af;" />
            </label>
            <div id="profile-msg" style="font-size:13px; min-height:20px;"></div>
            <button type="submit" class="btn btn-primary" style="align-self:flex-end; padding:8px 20px; border-radius:6px; background:#2563eb; color:#fff; border:none; cursor:pointer;">
              Save Changes
            </button>
          </form>
        </div>
      </div>
    </div>
  `;

  const form = container.querySelector('#profile-form') as HTMLFormElement;
  const msg = container.querySelector('#profile-msg') as HTMLElement;

  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const formData = new FormData(form);
    const data = { name: formData.get('name') as string, email: formData.get('email') as string };
    msg.textContent = 'Saving...';
    msg.style.color = '#9ca3af';
    try {
      await updateCurrentUser(data);
      msg.textContent = 'Profile updated successfully.';
      msg.style.color = '#22c55e';
      if (globalState.user) {
        globalState.user = {
          ...globalState.user,
          name: data.name,
          email: data.email,
        };
      }
    } catch (err: any) {
      msg.textContent = 'Error: ' + (err.message || 'Update failed');
      msg.style.color = '#ef4444';
    }
  });

  return container;
}
